<div id="placement">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 text-center">
                <h3 class="card-title">Our Recruiters</h3>
                <hr class="pb-1 rounded">
                <div class="row">
                    <img src="/assets/img/hiring/20.jpg" alt="" class="img-fluid mx-auto">
                    <img src="/assets/img/hiring/19.PNG" alt="" class="img-fluid mx-auto">
                </div>
                <div class="row mt-5">
                    <div class="col-12">
                        <div id="detail" class="text-center">
                            <pdf-viewer [src]="src" [render-text]="true" style="display: block;"
                                id="list-view"></pdf-viewer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>